<template>
  <div id="recon-test" class="recon-test" />
</template>
<script setup lang="ts">
  import { useHead } from 'nuxt/app';

  defineOptions({
    name: 'ReconTestPage',
  });

  useHead({
    meta: [
      {
        name: 'robots',
        content: 'noindex, nofollow',
      },
    ],
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
</style>
